import {
  DomainSessionId,
  NonEmptyText,
  ProductType,
  SessionId,
  UserId,
} from '@hc-frontend/core-types';
import { z } from 'zod';

export const VisitDto = z.object({
  domain_session_id: DomainSessionId,
  journey_id: NonEmptyText,
  plate_id: NonEmptyText,
  product: ProductType,
  session_id: SessionId,
  user_id: UserId,
});

export type VisitDto = z.infer<typeof VisitDto>;
